import { getMessages } from '../../../../../../store/constants';

export const BOARDS_ADD_OPEN = getMessages().getText('nav_panel.boards.open');
